var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"flat":"","dark":""},on:{"click":_vm.logoutAndRedirect}},[_c('v-icon',[_vm._v("lock_open")]),_vm._v("\n   Sign out"),(_vm.currentUser)?_c('span',[_vm._v(": "+_vm._s(_vm.currentUser.FirstName)+" "+_vm._s(_vm.currentUser.LastName))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }